<div class="bg-plum-plate pt-5 pl-5 pr-5 mb-5 rounded">
    <div class="row">
        <div class="col-xl-3 col-md-6">
            <a [routerLink]="" class="mb-5 card card-box card-box-border-bottom border-success card-box-hover-rise-alt">
                <div class="card-body">
                    <div class="align-box-row">
                        <div class="text-left">
                            <div class="mt-1">
                                <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg text-black pr-1">2,345</b>
                                <span class="text-black-50">users</span>
                            </div>
                        </div>
                        <div class="ml-auto card-hover-indicator">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-3 col-md-6">
            <a [routerLink]="" class="mb-5 card card-box card-box-border-bottom border-danger card-box-hover-rise-alt">
                <div class="card-body">
                    <div class="align-box-row">
                        <div class="text-left">
                            <div class="mt-1">
                                <fa-icon [icon]="['far', 'keyboard']" class="font-size-xxl text-danger"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg text-black pr-1">3,568</b>
                                <span class="text-black-50">clicks</span>
                            </div>
                        </div>
                        <div class="ml-auto card-hover-indicator">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-3 col-md-6">
            <a [routerLink]="" class="mb-5 card card-box card-box-border-bottom border-warning card-box-hover-rise-alt">
                <div class="card-body">
                    <div class="align-box-row">
                        <div class="text-left">
                            <div class="mt-1">
                                <fa-icon [icon]="['far', 'chart-bar']" class="font-size-xxl text-warning"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg text-black pr-1">$9,693</b>
                                <span class="text-black-50">revenue</span>
                            </div>
                        </div>
                        <div class="ml-auto card-hover-indicator">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-3 col-md-6">
            <a [routerLink]="" class="mb-5 card card-box card-box-border-bottom border-info card-box-hover-rise-alt">
                <div class="card-body">
                    <div class="align-box-row">
                        <div class="text-left">
                            <div class="mt-1">
                                <fa-icon [icon]="['far', 'building']" class="font-size-xxl text-info"></fa-icon>
                            </div>
                            <div class="mt-2 line-height-sm">
                                <b class="font-size-lg text-black pr-1">431</b>
                                <span class="text-black-50">sales</span>
                            </div>
                        </div>
                        <div class="ml-auto card-hover-indicator">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>